import { colors, boxShadows } from '@insurancemenu/imenu-components-lib/dist/utils';
import { createUseStyles } from 'react-jss';

const styles = {
  cardWrapper: {
    display: 'flex',
    flexDirection: 'column',
    padding: '3rem 2rem 4rem',
    background: colors.neutral.white,
    boxShadow: boxShadows.dark[16],
    borderRadius: '1rem',
  },
  cardHeader: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: '2rem',
  },
  cardTitle: {
    fontSize: '2rem',
    lineHeight: '2.8rem',
    color: colors.neutral.black,
    letterSpacing: '0.0225em',
  },
  descriptionList: {
    paddingLeft: 0,
    paddingBottom: '3rem',
    marginBottom: '3rem',
    borderBottom: `0.1rem solid ${colors.neutral[300]}`,
    listStyle: 'none',
    flexGrow: 1,
  },
  descriptionItem: {
    fontSize: '1.6rem',
    lineHeight: '2.4rem',
    display: 'grid',
    gap: '1.5rem',
    gridTemplateColumns: '2.4rem auto',

    '&:not(:last-child)': {
      marginBottom: '1rem',
    },
  },
  continueButton: {
    margin: '0 auto',
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
